import { forwardRef, InputHTMLAttributes } from "react";
import { cn } from "@/utils/cn";

export interface LoginInputProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label?: string;
  error?: string;
}

/** Text input for the login page — 48px tall, 12px radius, login theme tokens
 *  (Figma AchieveOS Sign In, node 163:28). */
export const LoginInput = forwardRef<HTMLInputElement, LoginInputProps>(
  ({ id, label, error, className, ...props }, ref) => (
    <div className="flex flex-col gap-2">
      {label && (
        <label
          htmlFor={id}
          className="text-[13px] font-medium leading-[19.5px] text-theme-login-label"
        >
          {label}
        </label>
      )}
      <input
        ref={ref}
        id={id}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : undefined}
        className={cn(
          "h-12 w-full rounded-[12px] border bg-theme-login-input-bg px-[14px] text-14 font-medium text-theme-login-input-text transition-colors duration-200 placeholder:text-theme-login-input-placeholder focus:outline-none focus:ring-1",
          error
            ? "border-error-500 focus:border-error-500 focus:ring-error-500"
            : "border-theme-login-input-border focus:border-theme-login-brand-text focus:ring-theme-login-brand-text",
          className,
        )}
        {...props}
      />
      {error && (
        <p id={`${id}-error`} className="text-12 text-error-500">
          {error}
        </p>
      )}
    </div>
  ),
);

LoginInput.displayName = "LoginInput";
